
import { ProfileTabs } from "../ProfileTabs";
import { ShareProfileSheet } from "../ShareProfileSheet";
import { PostModal } from "../PostModal";
import { Profile } from "@/hooks/useProfile";
import { Cast } from "@/hooks/useCasts";
import { Post } from "@/hooks/posts/types";
import { useState } from "react";

interface ProfileViewContentProps {
  profile: Profile;
  posts: Post[];
  casts: Cast[];
  userCropPlans: any[];
  activeTab: string;
  setActiveTab: (tab: string) => void;
  selectedCropForTimelapse: string | null;
  setSelectedCropForTimelapse: (crop: string | null) => void;
  selectedPostForPopup: Post | null;
  setSelectedPostForPopup: (post: Post | null) => void;
  onEditClick: () => void;
  onRemoveCrop: (cropId: string, cropName: string) => void;
  onToggleSolved?: (castId: string) => void;
  onEditPost?: (post: Post) => void;
  onDeletePost?: (postId: string) => void;
  isOwner?: boolean;
}

export const ProfileViewContent = ({
  profile,
  posts,
  casts,
  userCropPlans,
  activeTab,
  setActiveTab,
  selectedCropForTimelapse,
  setSelectedCropForTimelapse,
  selectedPostForPopup,
  setSelectedPostForPopup,
  onEditClick,
  onRemoveCrop,
  onToggleSolved,
  onEditPost,
  onDeletePost,
  isOwner = false
}: ProfileViewContentProps) => {
  const [showShareSheet, setShowShareSheet] = useState(false);

  console.log('🔍 ProfileViewContent - onToggleSolved prop:', !!onToggleSolved);

  const handleTimelapseClick = (crop: string) => {
    setSelectedCropForTimelapse(crop);
  };

  const handlePostClick = (post: Post) => {
    setSelectedPostForPopup(post);
  };

  const handleDeletePost = async (postId: string) => {
    if (onDeletePost) {
      await onDeletePost(postId);
    }
  };

  return (
    <>
      <div className="space-y-6">
        <ProfileTabs
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          profile={profile}
          posts={posts}
          casts={casts}
          userCropPlans={userCropPlans}
          onTimelapseClick={handleTimelapseClick}
          onPostClick={handlePostClick}
          onRemoveCrop={onRemoveCrop}
          onToggleSolved={onToggleSolved}
          onEditPost={onEditPost}
          onDeletePost={handleDeletePost}
          isOwner={isOwner}
        />
      </div>

      <ShareProfileSheet
        profile={profile}
        open={showShareSheet}
        onOpenChange={setShowShareSheet}
      />

      {selectedPostForPopup && (
        <PostModal
          post={selectedPostForPopup}
          onClose={() => setSelectedPostForPopup(null)}
        />
      )}
    </>
  );
};
